import { useNavigate } from "react-router-dom";
import { STAGES } from "@/lib/mh";
import { money } from "@/lib/onb";
import { mid, deptTotals, roleStatus } from "@/lib/sky";

const Strip = ({ list, hex }) => (
  <>
    <div className="flex h-1.5 gap-0.5 rounded-full overflow-hidden mt-4">
      {STAGES.map((s, i) => <span key={s} style={{ flexGrow: list.filter((a) => a.stage === s).length || 0.2, background: hex, opacity: 0.35 + i * 0.2 }} />)}
    </div>
    <div className="grid grid-cols-4 mt-1.5 font-mono text-[9px] uppercase tracking-wider text-muted-foreground">
      {STAGES.map((s) => <span key={s}>{s.slice(0, 5)} {list.filter((a) => a.stage === s).length}</span>)}
    </div>
  </>
);

const Chips = ({ list, hex }) => {
  const max = Math.max(1, ...list.map(mid));
  return (
    <div className="flex flex-wrap items-center gap-1.5 mt-4">
      {list.map((a) => {
        const t = a.tailored, sz = t ? (t.enabled ? 6 + 10 * Math.sqrt(mid(a) / max) : 5) : 8;
        const live = a.runtime?.status === "live";
        return <span key={a.slug} title={a.name} className="rounded-full border" style={{ width: sz, height: sz, borderColor: hex, background: live ? hex : "transparent", opacity: t && !t.enabled ? 0.3 : 1 }} />;
      })}
    </div>
  );
};

const DeptPanel = ({ d, i, list, needsDept, onClick }) => {
  const tot = deptTotals(list, (a) => roleStatus(a, needsDept));
  return (
    <button onClick={onClick} data-testid={`map-panel-${d.slug}`} style={{ animationDelay: `${i * 60}ms`, borderColor: `${d.hex}33` }}
      className="mh-rise text-left rounded-xl border bg-[#0A0A0F]/80 backdrop-blur-xl p-5 transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1 hover:bg-white/[0.03]">
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-display text-3xl" style={{ color: d.hex }}>{d.name}</div>
          <div className="font-mono text-[10px] text-muted-foreground mt-0.5">{d.tagline}</div>
        </div>
        {tot.needs > 0 && <span className="font-mono text-[10px] text-[#FFB020] whitespace-nowrap" data-testid={`map-panel-needs-${d.slug}`}>{tot.needs} need input</span>}
      </div>
      <div className="text-xs mt-3" data-testid={`map-panel-totals-${d.slug}`}>
        <span className="text-foreground">{tot.active}</span><span className="text-muted-foreground"> of {tot.total} active</span>
        {tot.tailored && <><span className="text-muted-foreground"> · </span><span className="text-[#D4FF3A]">${money(tot.money)}</span><span className="text-muted-foreground">/mo</span></>}
        {tot.wave && <span className="text-muted-foreground"> · wave {tot.wave}</span>}
      </div>
      <Strip list={list} hex={d.hex} />
      <Chips list={list} hex={d.hex} />
    </button>
  );
};

export const MapOverview = ({ deps, agents, needs }) => {
  const nav = useNavigate();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="map-overview">
      {deps.map((d, i) => <DeptPanel key={d.slug} d={d} i={i} list={agents.filter((a) => a.department === d.slug)} needsDept={needs(d.slug)} onClick={() => nav(`/map/${d.slug}`)} />)}
    </div>
  );
};
